var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModernHaircut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219 219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 158,
    y1: 197,
    x2: 96,
    y2: 103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eab26d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcead5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 50,
    y1: 24,
    x2: 150,
    y2: 144
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e76500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4545c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M205 90c0-33-16-47-28-50-3-9-8-14-9-15-2-3-20-25-56-25-12 0-25 3-39 8-16 6-55 27-58 80-4 60 48 107 50 109l3 1a4 4 0 0 0 4-5l-1-2c10 12 20 19 28 24a42 42 0 0 0 39 0c11-6 26-17 38-39 8-14 13-31 15-46 7-8 14-20 14-40z",
    fill: "url(#c)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 0c-12 0-25 3-39 8-16 6-55 27-58 80-4 60 48 107 50 109l3 1a4 4 0 0 0 4-5l-1-3-3-19c-2-15-1-35 11-45 10-8 25-11 41-15 19-4 38-9 49-22 4 3 7 7 8 12 4 18-1 32-1 33a4 4 0 0 0 5 5c0-1 6-4 10-9 7-8 14-20 14-40 0-33-16-47-28-50-3-9-8-14-9-15-2-3-20-25-56-25z",
    fill: "url(#d)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernHaircut);
export default __webpack_public_path__ + "static/media/modern-haircut.14f7f790834cf0fb7117377eec3dbbbd.svg";
export { ForwardRef as ReactComponent };